import {
    CustomerDetail
} from 'one-state-servicenow-verify/src/ServicenowVerify';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * ServiceNow Verify Component
 * @param response has the backend upcoming
 * appointment response
 * @param context has settings etc..
 */
export const TransformResponse = (response: any, context: any) => {
    /**
     * @param result contains the transformed response
     */
    const result: CustomerDetail[] = [];

    let servicecallerresult: any = {
        servicecallerdata: result,
        error: undefined

    }
    const { log, settings: { epicendpoints } } = context;
    log.debug("on-epic", "transformation entered", response);
    // TODO:verify backend team check for errors
    if (response && (response.status >= 400 || response.type == "error")) {
        servicecallerresult.error = response;
    }
    //Checking if got response from the Backend
    else if (response && response.length > 0) {
        response.map((responseinfo: any)=>{
            if(responseinfo && responseinfo?.result?.length > 0) {
                responseinfo.result.map((datainfo:any)=>{
                    let customerinfo: CustomerDetail = {
                        id: "",
                        city:"",
                        country:"",
                        mobile_phone:"",
                        email:"",
                        name:"",
                        phone:"",
                        state:"",
                        street:"",
                        zip:""
                    }
                    //Fetching the required data from the response.
                   if(datainfo) {
                    customerinfo.id = datainfo ? datainfo.employee_number : "";
                    customerinfo.city= datainfo ? datainfo.city : "";
                    customerinfo.country = datainfo ? datainfo.country : "";
                    customerinfo.mobile_phone = datainfo ? datainfo.mobile_phone : "";
                    customerinfo.email = datainfo ? datainfo.email : "";
                    customerinfo.name = datainfo ? datainfo.name : "";
                    customerinfo.phone = datainfo ? datainfo.phone : "";
                    customerinfo.state = datainfo ? datainfo.state : "";
                    customerinfo.street = datainfo ? datainfo.street : "";
                    customerinfo.zip = datainfo ? datainfo.zip : ""
                   }
                    result.push(customerinfo);
                })
            }
        })
    }
    servicecallerresult.servicecallerdata = result;
    log.debug("one-epic", "Customer-Details Transform result",servicecallerresult );
    return servicecallerresult;
}



